export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/fashion_and_apparel.a441406.svg";